var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-3 user-metadata-view" }, [
    _vm.fetchingUserAdditionalStats
      ? _c("div", [_vm._m(0)])
      : !_vm.tweetUserAdditionalStats
      ? _c(
          "button",
          {
            staticClass: "btn btn-primary",
            on: {
              click: function($event) {
                return _vm.requestAdditionalUserDataHandler()
              }
            }
          },
          [_vm._v("\n        Request additional user metadata\n    ")]
        )
      : _c("div", [
          _c("h3", [_vm._v("User Timeline Analysis")]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "col-7" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.tweetUserAdditionalStats.timeline_num_posts) +
                  "\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _c("strong", [_vm._v("Post histogram")]),
          _vm._v(" "),
          "datasets" in _vm.tweetHistogramData
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "form-row" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("date-range-picker", {
                          ref: "picker",
                          staticStyle: { width: "100%" },
                          attrs: {
                            "locale-data": _vm.datepickerLocale,
                            timePicker: true,
                            timePicker24Hour: true,
                            dateUtil: "moment"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "input",
                                fn: function(picker) {
                                  return [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm._f("date")(picker.startDate)
                                        ) +
                                        " - " +
                                        _vm._s(_vm._f("date")(picker.endDate)) +
                                        "\n                        "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            595309827
                          ),
                          model: {
                            value: _vm.dateRange,
                            callback: function($$v) {
                              _vm.dateRange = $$v
                            },
                            expression: "dateRange"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-row mt-1 mb-2" }, [
                    _c("div", { staticClass: "col" }, [
                      _c("div", { staticClass: "btn-group btn-group-toggle" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.setHistoryMode("hours")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Hourly\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.setHistoryMode("days")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Daily\n                        "
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col" }, [
                      _c(
                        "button",
                        {
                          staticClass: "form-control btn btn-warning",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.resetDates()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        Reset dates\n                    "
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("tweet-histogram", {
                    attrs: { "chart-data": _vm.tweetHistogramData }
                  })
                ],
                1
              )
            : _c("p", [_vm._v("No user post history")]),
          _vm._v(" "),
          _c("strong", [_vm._v("Hashtags")]),
          _vm._v(" "),
          _vm.tweetUserAdditionalStats.timeline_hashtags
            ? _c(
                "div",
                [
                  _c("wordcloud", {
                    attrs: {
                      data: _vm.tweetUserAdditionalStats.timeline_hashtags,
                      nameKey: "name",
                      valueKey: "value",
                      color: _vm.wordCloudColours,
                      rotate: _vm.wordCloudRotation,
                      "font-size": _vm.wordCloudFontSize,
                      showTooltip: false
                    }
                  })
                ],
                1
              )
            : _c("p", [_vm._v("No hashtags")]),
          _vm._v(" "),
          _c("strong", [_vm._v("User mentions")]),
          _vm._v(" "),
          _vm.tweetUserAdditionalStats.timeline_user_mentions
            ? _c(
                "div",
                [
                  _c("wordcloud", {
                    attrs: {
                      data: _vm.tweetUserAdditionalStats.timeline_user_mentions,
                      nameKey: "name",
                      valueKey: "value",
                      color: _vm.wordCloudColours,
                      rotate: _vm.wordCloudRotation,
                      "font-size": _vm.wordCloudFontSize,
                      showTooltip: false
                    }
                  })
                ],
                1
              )
            : _c("p", [_vm._v("No user mentions")]),
          _vm._v(" "),
          _c("strong", [_vm._v("Most retweeted users")]),
          _vm._v(" "),
          _vm.tweetUserAdditionalStats.timeline_retweets
            ? _c(
                "div",
                [
                  _c("wordcloud", {
                    attrs: {
                      data: _vm.tweetUserAdditionalStats.timeline_retweets,
                      nameKey: "name",
                      valueKey: "value",
                      color: _vm.wordCloudColours,
                      rotate: _vm.wordCloudRotation,
                      "font-size": _vm.wordCloudFontSize,
                      showTooltip: false
                    }
                  })
                ],
                1
              )
            : _c("p", [_vm._v("No retweeted users")]),
          _vm._v(" "),
          _c("strong", [_vm._v("Tweet Locations")]),
          _vm._v(" "),
          _vm.tweetUserAdditionalStats.timeline_coordinates
            ? _c(
                "div",
                [
                  _c("g-maps", {
                    attrs: {
                      coords: _vm.tweetUserAdditionalStats.timeline_coordinates
                    }
                  })
                ],
                1
              )
            : _c("p", [_vm._v("No locations")]),
          _vm._v(" "),
          _c("strong", [_vm._v("Sources")]),
          _vm._v(" "),
          _vm.tweetUserAdditionalStats.timeline_sources
            ? _c(
                "ul",
                _vm._l(_vm.tweetUserAdditionalStats.timeline_sources, function(
                  source
                ) {
                  return _c("li", [
                    _vm._v(_vm._s(source.text) + " "),
                    _c("span", { staticClass: "badge badge-info" }, [
                      _vm._v(_vm._s(source.weight))
                    ])
                  ])
                }),
                0
              )
            : _c("p", [_vm._v("No sources")]),
          _vm._v(" "),
          _c("strong", [_vm._v("Languages")]),
          _vm._v(" "),
          _vm.tweetUserAdditionalStats.timeline_languages
            ? _c(
                "ul",
                _vm._l(
                  _vm.tweetUserAdditionalStats.timeline_languages,
                  function(language) {
                    return _c("li", [
                      _vm._v(_vm._s(language.text) + " "),
                      _c("span", { staticClass: "badge badge-info" }, [
                        _vm._v(_vm._s(language.weight))
                      ])
                    ])
                  }
                ),
                0
              )
            : _c("p", [_vm._v("No languages detected")])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "font-weight-bold" }, [
      _c("span", {
        staticClass: "spinner-grow spinner-grow-sm mr-2",
        attrs: { role: "status", "aria-hidden": "true" }
      }),
      _vm._v("\n            Fetching replies ...\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-5 t" }, [
      _c("strong", [_vm._v("Num collected posts")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }